import { createContext } from 'react'

const ScheduledPickupContext = createContext()

export default ScheduledPickupContext
